import {
  Button,
  Container,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { sgiurl, sgiurlv1, url } from "../../baseUrl";
import DatatablePage from "../../Components/DataTable/DataTable";
import CustomizedSnackbars from "../../Components/SnackBar/SnackBar";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import CreateIcon from "@mui/icons-material/Create";
import {
  brandName,
  darkButton,
  lightBackground,
  lightText,
  white,
} from "../../Assets/Theme/ThemeColors";
import { useDispatch, useSelector } from "react-redux";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import ReplayIcon from "@mui/icons-material/Replay";

import RefreshIcon from "@mui/icons-material/Refresh";
import {
  copyToClipboard,
  copyToClipboardTruncate,
} from "../../Helpers/CommonFunctions";
import { userUnAuthorized } from "../../redux/actions/commonAction";

const TransactionList = () => {
  const user = useSelector((state) => state.user.data.data.user);
  const state = useSelector((state) => state.user);
  const token = state.data.token;
  const isAdmin = user.user_type === "admin" ? true : false;
  // console.log("token", token);

  const [data, setData] = useState();
  const [branch, setBranch] = useState(
    isAdmin
      ? sessionStorage.getItem("selectedBranch")
        ? sessionStorage.getItem("selectedBranch")
        : "KHI"
      : user.branch_code
  );
  const [brand, setBrand] = useState(
    sessionStorage.getItem("selectedBrand")
      ? sessionStorage.getItem("selectedBrand")
      : ""
  );
  const [allBranch, setAllBranch] = useState([]);
  const [allBrands, setAllBrands] = useState([]);

  const [isLoaded, setIsLoaded] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const navigate = useNavigate();

  const currencyFormatter = (amount, currencyType) => {
    var formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currencyType,

      // These options are needed to round to whole numbers if that's what you want.
      //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
      //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });
    return formatter.format(amount);
  };
  const transactionObject = {
    transactionId: "1234567",
    year: 2022,
    month: "april",
    dateTime: "22/04/2022-13:00",
    custName: "Customer1",
    custEmail: "cust1@gmail.com",
    custContactNumber: "01234567",
    brand: "CyberClosys",
    brandService: "abcd",
    packageName: "standard",
    saleType: "one time",
    salePerson: "peter",
    amount: 200,
    discount: 30,
    additionalCharges: 10,
    total: 180,
    discription: "wordpress",
    detailDiscription: "qwertyuiopasdfghjklzxcvbnm",
    invoiceLink: "http:abcd.com/invoice_000000",
  };

  const columns = [
    {
      label: "Action",
      field: "action",
      sort: "asc",
      width: 100,
    },
    {
      label: "Year",
      field: "year",
      sort: "asc",
      width: 100,
    },
    {
      label: "Month",
      field: "month",
      sort: "asc",
      width: 100,
    },

    {
      label: "Date",
      field: "dateTime",
      sort: "asc",
      width: 200,
    },

    {
      label: "Customer Name",
      field: "custNameAct",
      sort: "asc",
      width: 250,
    },
    {
      label: "Email Address",
      field: "custEmailAct",
      sort: "asc",
      width: 250,
    },
    {
      label: "Phone Number",
      field: "custContactNumberAct",
      sort: "asc",
      width: 250,
    },
    {
      label: "Brand",
      field: "brandAct",
      sort: "asc",
      width: 150,
    },
    {
      label: "Order ID",
      field: "orderIdAct",
      sort: "asc",
      width: 150,
    },

    {
      label: "Type Of Sale",
      field: "saleType",
      sort: "asc",
      width: 150,
    },
    {
      label: "Sale's Person",
      field: "salePerson",
      sort: "asc",
      width: 250,
    },
    {
      label: "Service",
      field: "detailDiscriptionfull",
      sort: "asc",
      width: 150,
    },
    {
      label: "Total Amount",
      field: "total",
      sort: "asc",
      width: 100,
    },
    {
      label: "Account",
      field: "account",
      sort: "asc",
      width: 100,
    },
    {
      label: "Payment Status",
      field: "paymentStatus",
      sort: "asc",
      width: 100,
    },
    {
      label: "Payment Time",
      field: "paymentTime",
      sort: "asc",
      width: 100,
    },
    {
      label: "Description",
      field: "discriptionFull",
      sort: "asc",
      width: 150,
    },
    {
      label: "Invoice-Link",
      field: "invoiceLinkFull",
      sort: "asc",
      width: 300,
    },
    {
      label: "Stripe ID",
      field: "stripeIdFull",
      sort: "asc",
      width: 150,
    },
  ];
  useEffect(() => {
    if (isAdmin) getAllBranches();
  }, []);

  useEffect(() => {
    getAllBrands();
  }, [branch]);

  useEffect(() => {
    if (brand != null && brand != "") {
      getAllTransactions();
    }
  }, [brand]);

  const getAllBrands = async () => {
    var branchCode = isAdmin ? branch : user.branch_code;
    await axios
      .get(`${sgiurl}/brands/getAllBrands?branchCode=${branchCode}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(async (response) => {
        let data = response.data.data;
        setAllBrands(data);
        if (!isAdmin) {
          setTimeout(() => {
            setBrand(data[0]?.name);
          }, 100);
        }
        console.log("brands", data);
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          console.log("unauthorized error");
          userUnAuthorized(dispatch);
        } else {
          console.log("network error");
          setIsLoaded(false);
          setIsOpen(true);
          setMessage(error.message);
          setSeverity("error");
        }
      });
  };

  const getAllBranches = async () => {
    await axios
      .get(`${url}/branch`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(async (response) => {
        let data = response.data.data;
        setAllBranch(data);
        console.log("branch", data);
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          console.log("unauthorized error");
          userUnAuthorized(dispatch);
        } else {
          console.log("network error");
          setIsLoaded(false);
          setIsOpen(true);
          setMessage(error.message);
          setSeverity("error");
        }
      });
  };
  const getAllTransactions = async () => {
    try {
      if (brand != null && brand != "") {
        setData([]);
        setIsLoaded(true);
        console.log("token 2", token);
        const response = await axios
          .post(
            `${sgiurlv1}/transactions/crm/getAllTransactions`,
            {
              brand: brand === "all" ? "" : brand,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then((data) => {
            console.log("data",data.data.data);

            setData({
              columns,
              rows: data.data.data.map((item) => ({
                ...item,
                custNameAct: copyToClipboard(item.custName),
                custEmailAct: copyToClipboard(item.custEmail),
                custContactNumberAct: copyToClipboard(item.custContactNumber),
                brandAct: copyToClipboard(item.brand),
                orderIdAct: copyToClipboard(item.orderId),
                detailDiscriptionfull: copyToClipboardTruncate(
                  item.detailDiscription
                ),
                discriptionFull: copyToClipboardTruncate(item.discription),
                invoiceLinkFull: copyToClipboardTruncate(item.invoiceLink),
                stripeIdFull: copyToClipboardTruncate(item.stripeId),
                total: currencyFormatter(
                  item.total,
                  allBrands.find((brand) => brand.name === item.brand)
                    ?.branchCode === "ECOM"
                    ? "USD"
                    : "GBP"
                ),
                paymentStatus: item.paymentStatus ? (
                  <Typography
                    variant="button"
                    style={{
                      width: "200px",
                      padding: "10px",
                      background: "green",
                      borderRadius: "5px",
                      color: "white",
                    }}
                  >
                    {" "}
                    paid
                  </Typography>
                ) : (
                  <Typography
                    variant="button"
                    style={{
                      width: "200px",
                      padding: "10px",
                      background: "red",
                      borderRadius: "5px",
                      color: "white",
                    }}
                  >
                    unpaid
                  </Typography>
                ),

                paymentTime: item.paymentStatus
                  ? new Date(item.updatedAt).toLocaleString("en-US", {
                      timeZone: "Asia/Karachi",
                    })
                  : "",
                action: (
                  <>
                    <span
                      onClick={() =>
                        navigate(`/transaction/${item._id}_readOnly`)
                      }
                      style={{ color: `${lightBackground}`, cursor: "pointer" }}
                      title="view "
                    >
                      <RemoveRedEyeIcon />
                    </span>
                  </>
                ),
              })),
            });
            setIsOpen(true);
            setMessage("Data Loaded!");
            setSeverity("success");
            setIsLoaded(false);
          });
      } else {
        setIsOpen(true);
        setMessage("Select Brand Name");
        setSeverity("warning");
      }
    } catch (error) {
      console.log("error", error.message);
      setIsLoaded(false);
      setIsOpen(true);
      setMessage(error.message);
      setSeverity("error");
    }
    setTimeout(() => {
      setIsOpen(false);
    }, 2000);
  };

  return (
    <>
      <Container
        style={{
          maxWidth: "100%",
          padding: "0px",
          overflowY: "scroll",
          height: "94vh",
        }}
      >
        <Paper fullWidth sx={{ m: 1, p: 2, maxWidth: "100%" }}>
          <Grid style={{ display: "flex", justifyContent: "flex-start" }}>
            <Typography variant="h5" color={`${lightText} `}>
              All Transactions
            </Typography>
          </Grid>
          <Grid
            xs={12}
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Grid item container md={5} xs={12} sx={{ p: 1 }}>
              {isAdmin ? (
                <Grid item md={3} xs={12}>
                  <FormControl margin="normal" fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Select Branch
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={branch}
                      margin="normal"
                      label="Select Branch"
                      onChange={(e) => {
                        sessionStorage.setItem(
                          "selectedBranch",
                          e.target.value
                        );
                        setBranch(e.target.value);
                      }}
                      disabled={isLoaded}
                    >
                      {allBranch?.length > 0 ? (
                        allBranch?.map((item) => {
                          return (
                            <MenuItem value={item.branchCode}>
                              {item.branchName}
                            </MenuItem>
                          );
                        })
                      ) : (
                        <MenuItem value={""}>None</MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </Grid>
              ) : (
                []
              )}
              <Grid item md={5} xs={12} sx={{ pl: 1 }}>
                <FormControl margin="normal" fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Select Brand Name
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={brand}
                    margin="normal"
                    label="Select Brand Name"
                    onChange={(e) => {
                      sessionStorage.setItem("selectedBrand", e.target.value);
                      setBrand(e.target.value);
                    }}
                    disabled={isLoaded}
                  >
                    {isAdmin && <MenuItem value={"all"}>All-Brands</MenuItem>}
                    {allBrands?.length > 0 ? (
                      allBrands?.map((item) => {
                        return (
                          <MenuItem value={item.name}>
                            {item.name} - {item.shortName}
                          </MenuItem>
                        );
                      })
                    ) : (
                      <MenuItem value={""}>None</MenuItem>
                    )}
                  </Select>
                </FormControl>
              </Grid>

              <Grid
                item
                md={3}
                xs={12}
                sx={{ p: 1, display: "flex", alignItems: "center" }}
              >
                <Button
                  onClick={getAllTransactions}
                  variant="contained"
                  style={{
                    background: `${lightBackground}`,
                    color: `${white}`,
                    display: "flex",
                    alignItems: "center",
                  }}
                  // color={`${darkButton}`}
                >
                  <RefreshIcon sx={{ mr: 1 }} />
                  Reload
                </Button>
              </Grid>
            </Grid>
            <Grid sx={{ p: 1, display: "flex", alignItems: "center" }}>
              <Button
                onClick={() => navigate(`/transaction/00000000000_CREATE`)}
                variant="contained"
                style={{ background: `${lightBackground}`, color: `${white}` }}
              >
                Generate New Link
              </Button>
            </Grid>
          </Grid>
          <DatatablePage data={data} isLoaded={isLoaded} />
        </Paper>
      </Container>
      <CustomizedSnackbars
        isOpen={isOpen}
        severity={severity}
        message={message}
      />
    </>
  );
};

export default TransactionList;
